import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/components/home/Home'
import AdminPages from '@/components/admin/AdminPages'
import ArticlesByCategory from '@/components/article/ArticlesByCategory'
import ArticleById from '@/components/article/ArticleById'
import Auth from '@/components/auth/Auth'


import SacPrincipal from '../components/sac_solicitacao/SacPrincipal'
//import SacSolicitacao from '../components/sac_solicitacao/SacSolicitacao'
import ManPreventivaLancamento from '../components/man_preventiva/ManPreventivaLancamento'
import ManutencaoRfiLancamento from '../components/man_rfi/ManutencaoRfiPrincipal'
import ManutencaoLavadorPrincipal from '../components/man_lavador/ManutencaoLavadorPrincipal'
import FrotaPrincipal from '../components/operacao_frota/FrotaPrincipal'
import TrafegoMonitoramento from '../components/trafego/TrafegoMonitoramento'
import DashboardOperacional from '../components/trafego/DashboardOperacional'
import LinhaPrincipal from '../components/pla_linha/LinhaPrincipal'
import PontoEletronicoPrincipal from '../components/flp_pontoeletronico/PontoEletronicoPrincipal'
import CorretivaPrincipal from '../components/man_corretiva/CorretivaPrincipal'





import { userKey } from '@/global'


Vue.use(VueRouter)

const routes = [
    {
        name: 'home',
        path: '/',
        component: Home
    }, 
    // PADRÃO ADOTANDO COM BASE NO MENU DO ERP O ID_MENU SERÁ O CAMPO ATRIBUIDO COMO PERMISSÃO DE ACESSO AOS USUÁRIOS

    

    {
        name: '87',  
        path: '/admin',
        component: AdminPages,
        meta: { requiresAdmin: true }
    }, 
    {
        name: '180',
        path: '/oficina/preventiva',
        component: ManPreventivaLancamento
    }, 

    {
        name: '183',
        path: '/manutencao/rfi',
        component: ManutencaoRfiLancamento
    }, 

    {
        name: '7',
        path: '/manutencao/lavador',
        component: ManutencaoLavadorPrincipal
    }, 

    {
        name: '8',
        path: '/sac/solicitacao',
        component: SacPrincipal
    }, 

    {
        name: '185',
        path: '/trafego/monitoramento',
        component: TrafegoMonitoramento
    },

    
    {
        name: '11',
        path: '/trafego/dashboardoperacional',
        component: DashboardOperacional
    }, 


    {   // implantação 29/09/2022 
        name: '10', 
        path: '/operacao_frota/frota',
        component: FrotaPrincipal
    },
    
    {   // implantação 12/10/2022 18:15
        name: '12', 
        path: '/pla_linha',
        component: LinhaPrincipal
    }, 

    {   // implantação 24/12/2022 18:24
        name: '14', 
        path: '/pontoeletronico',
        component: PontoEletronicoPrincipal
    }, 

    {   // implantação 26/12/2022 16:14
        name: '179', 
        path: '/manutencao/corretiva',
        component: CorretivaPrincipal
    }, 



    {
        name: 'articlesByCategory',
        path: '/categories/:id/articles',
        component: ArticlesByCategory
    }, 

    {
        name: 'articleById',
        path: '/articles/:id',
        component: ArticleById
    }, 
    
    {
        name: 'auth',
        path: '/auth',
        component: Auth
    }    
]
const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    const json = localStorage.getItem(userKey)

    if(to.matched.some(record => record.meta.requiresAdmin)) {
        const user = JSON.parse(json)
        user && user.admin ? next() : next({ path: '/' })
    } else {
        next()
    }
})

export default router
